<template>
  <div class="cart-subscription-item">
    <div class="flex flex-row gap-2 sm:gap-0">
      <div class="flex-initial w-1/3 pr-2 lg:min-w-max">
        <img :src="getImage(data)" class="product__image" />
      </div>
      <div class="flex-1 lg:w-auto">
        <div class="cart-subscription-item__content">
          <div class="text-base font-normal">
            {{ data.product_name }}
          </div>
          <div class="text-xs leading-normal text-gray-50 mt-1" v-show="data.sku.sku_item_parent_name_1">
            <i18n path="common.label.formatSKU">
              <template #sku_name>
                <span class="break-all">{{ data.sku.sku_item_parent_name_1 }}</span>
              </template>
              <template #sku_value
                ><span class="break-all">{{ data.sku.sku_set_item_name1 }}</span></template
              >
            </i18n>
          </div>
          <div class="text-xs leading-normal text-gray-50 mt-1" v-show="data.sku.sku_item_parent_name_2">
            <i18n path="common.label.formatSKU">
              <template #sku_name>
                <span class="break-all"> {{ data.sku.sku_item_parent_name_2 }}</span>
              </template>
              <template #sku_value
                ><span class="break-all">{{ data.sku.sku_set_item_name2 }}</span></template
              >
            </i18n>
          </div>
          <div class="text-xs leading-normal text-gray-50 mt-1 break-all">
            {{ $t('ec-line014.cart.quantity', { value: data.sku.quantity }) }}
          </div>
          <div class="text-base text-black font-medium mt-1 flex">
            <i18n path="common.cart.formatLabel" class="flex items-center">
              <template #label>
                <span>{{ $t('common.cart.subTotal') }}</span>
              </template>
              <template #tax>
                <span class="tax-font">{{ $t('common.cart.withTax') }}</span>
              </template>
            </i18n>
            <span>{{ $t('cartList.item.separatorColon') }}</span>
            <i18n path="common.cart.formatPrice">
              <template #price>
                <span>{{ subtotal.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </div>
          <div v-if="subdiscount < 0" class="text-xs mt-1">
            <i18n path="common.cart.formatLabel">
              <template #label>
                <span class="font-light">{{ $t('common.label.priceDiscount') }}</span>
              </template>
            </i18n>
            <span class="font-light">{{ $t('cartList.item.separatorColon') }}</span>
            <i18n path="common.cart.formatPrice" class="text-red">
              <template #price>
                <span>{{ subdiscount.toLocaleString() }}</span>
              </template>
              <template #unit>
                <span class="text-xxs">{{ $t('common.cart.yen') }}</span>
              </template>
            </i18n>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ENV_KEY } from '@/constants/env'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    subtotal() {
      return Number(this.data.sku.next_subtotal_price03_after_tax)
    },
    subdiscount() {
      return Number(this.data.sku.next_subtotal_discount_amount)
    },
  },
  methods: {
    getImage(data) {
      return `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${data.product_image}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-subscription-item.scss';
</style>
